import React, { useCallback, useMemo } from 'react';
import { PlotlyComponent } from 'components';
import { Pages, getAmountOfPlots, updateAxis, DEFAULT_PLOT_RANGE, Tab } from 'utils';
import { usePlotlyDataOptimizer } from 'hooks';
import { CustomSelection } from '../CustomSelection/CustomSelection';

export const PlotlyFromApi = ({
    title,
    sideModalTitle,
    localization,
    legendPosition,
    isLoading,
    selectionState,
    data,
    isLegendShown = true,
}: any) => {
    const {
        dropDownAllCategories,
        year,
        perAnnum,
        hareSelection,
        dropDownHeritage,
        range = DEFAULT_PLOT_RANGE,
    } = selectionState;
    const { aggregatedBy } = hareSelection || {};

    const dataFromSelection = useCallback(() => {
        switch (title) {
            case Tab.POPULATION:
                return data;
            case Tab.DEMOGRAPHIC:
                return data;
            case Tab.DRIVERS_OF_GROWTH:
                return data[year];
            case Tab.CATEGORY_SPEND:
                return data[perAnnum];
            case Tab.CURRENT_SPEND:
                return data[dropDownHeritage][dropDownAllCategories];
            case Tab.DISPOSABLE_INCOME:
                return data[perAnnum];
            default: {
                let resultPath = '';
                for (const key in selectionState) {
                    resultPath += selectionState[key];
                }

                return data[resultPath];
            }
        }
    }, [data, dropDownAllCategories, dropDownHeritage, perAnnum, selectionState, title, year]);

    const updatedData = useMemo(() => {
        return updateAxis(dataFromSelection(), range, title, legendPosition === 'top');
    }, [dataFromSelection, range, legendPosition, title]);

    const firstPlot = usePlotlyDataOptimizer({
        data: updatedData,
        type: title,
        isNoneCase: aggregatedBy === 'None',
        localization,
    });

    return (
        <>
            {data && (
                <PlotlyComponent
                    plotlyData={[firstPlot]}
                    plotHeight={getAmountOfPlots(updatedData?.layout ?? 1)}
                    sideModalTitle={sideModalTitle}
                    legendTitle={title}
                    legendPosition={legendPosition}
                    localization={localization}
                    isLoading={isLoading}
                    isLegendShown={isLegendShown}
                    isLegendsListShown={aggregatedBy !== 'None' || title === Tab.DRIVERS_OF_GROWTH}
                    page={Pages.PROJECTION}
                >
                    <CustomSelection
                        title={title}
                        withSingleSlider={title === Tab.DRIVERS_OF_GROWTH}
                        localization={localization}
                    />
                </PlotlyComponent>
            )}
        </>
    );
};
